<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Seleccione un aval</h4>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row" *ngIf="intermediaries.length">
      <select class="form-control" [(ngModel)]="selectedIntermediary">
        <option *ngFor="let inter of intermediaries" [ngValue]="inter">[{{ inter.code }}] {{ inter.fullName }}</option>
      </select>
    </div>

    <p *ngIf="!isRequesting && !intermediaries.length">Este cliente no posee aval para seleccionar</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="confirm()">Confirmar</button>
  </div>
</div>